function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M280.161 31.2601C310.941 3.83006 359.27 -1.73994 403.25 0.420062C541.411 7.29006 666.121 73.9801 773.991 149.42C813.041 176.73 851.491 206.16 876.841 243.77C928.44 320.34 913.141 426.4 841.38 489.47C816.971 510.93 787.381 527.39 756.991 541.97C702.991 567.9 644.681 588.71 583.371 594.64C539.641 598.86 495.371 595.43 451.911 589.53C330.471 573.06 211.26 536.64 111.35 474.33C67.5305 447 26.2205 413.03 8.16051 368.82C-9.89949 324.61 1.6605 268.58 46.4005 242.41C64.9105 231.59 87.0405 226.7 108.701 222.11C140.59 215.35 172.991 208.69 201.761 194.96C231.481 180.77 266.681 153.33 260.761 121.96C254.481 88.2501 249.411 58.6601 280.161 31.2601Z",
  fill: "#6C63FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M353.44 788.01C435.576 788.01 502.16 776.222 502.16 761.68C502.16 747.138 435.576 735.35 353.44 735.35C271.304 735.35 204.72 747.138 204.72 761.68C204.72 776.222 271.304 788.01 353.44 788.01Z",
  fill: "#6C63FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M752.81 773.12C794.557 773.12 828.4 765.666 828.4 756.47C828.4 747.274 794.557 739.82 752.81 739.82C711.063 739.82 677.22 747.274 677.22 756.47C677.22 765.666 711.063 773.12 752.81 773.12Z",
  fill: "#6C63FF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M372.48 469.54L366.32 467.71L366.61 472.19L380.4 477.46L377.9 470.04L372.48 469.54Z",
  fill: "#FF3B30"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.03,
  d: "M372.48 469.54L366.32 467.71L366.61 472.19L380.4 477.46L377.9 470.04L372.48 469.54Z",
  fill: "black"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M568.63 669.75C621.135 616.589 650.529 544.848 650.42 470.13C650.42 469.33 650.42 468.53 650.42 467.72H366.6L568.63 669.75Z",
  fill: "#FF3B30"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.03,
  d: "M568.63 669.75C621.135 616.589 650.529 544.848 650.42 470.13C650.42 469.33 650.42 468.53 650.42 467.72H366.6L568.63 669.75Z",
  fill: "black"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M568.63 674.22C621.135 621.059 650.529 549.318 650.42 474.6C650.42 473.79 650.42 472.99 650.42 472.19H366.6L568.63 674.22Z",
  fill: "#FF453A"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M826.8 424.5L822.42 384.97C822.42 384.97 814.49 349.38 813.36 331.59C812.23 313.8 803.66 312.5 803.59 312.5C803.59 312.5 793.02 306.32 792.08 304.26C791.35 302.68 785.48 299.32 782.82 297.84L781.52 297.15C781.52 297.15 778.22 283.4 774.29 285.37L773.97 284.44C772.939 281.482 772.316 278.397 772.12 275.27C772.12 274.88 772.12 274.5 772.12 274.12C776.443 269.912 779.553 264.616 781.12 258.79C781.653 256.74 781.987 254.644 782.12 252.53C782.12 252.14 782.12 251.74 782.12 251.34C784.05 249.99 784.37 247.13 784.88 244.74C785.82 240.36 788.28 236.44 789.45 232.12C789.55 231.75 789.63 231.37 789.7 230.98C789.7 230.9 789.7 230.82 789.7 230.73C789.842 229.938 789.919 229.135 789.93 228.33C789.93 228.27 789.93 228.22 789.93 228.16C789.93 224.9 788.93 221.7 786.23 219.96C785.606 219.637 785.028 219.234 784.51 218.76C784.125 218.286 783.827 217.748 783.63 217.17L781.63 212.41C781.413 211.785 781.073 211.211 780.63 210.72C779.837 210.118 778.928 209.685 777.96 209.45C774.96 208.3 772.96 205.51 771.49 202.73C770.02 199.95 768.67 196.95 766.38 194.73C762.66 191.18 757.14 190.43 752.02 189.87C751.641 191.471 751.52 193.121 751.66 194.76C743.53 192.98 734.66 191.27 727.17 194.86C725.838 195.41 724.765 196.447 724.17 197.76C724.121 197.914 724.081 198.071 724.05 198.23C724.03 198.433 724.03 198.637 724.05 198.84C724.147 199.276 724.191 199.723 724.18 200.17C724.094 200.477 723.935 200.759 723.717 200.992C723.5 201.225 723.23 201.402 722.93 201.51C720.47 202.6 717.5 201.19 714.93 202.06C712.58 202.86 711.28 205.33 710.55 207.69C709.82 210.05 709.35 212.58 707.76 214.47C706.96 215.47 705.91 216.14 705.08 217.07C704.328 217.933 703.771 218.948 703.445 220.045C703.119 221.142 703.032 222.296 703.19 223.43C703.185 223.49 703.185 223.55 703.19 223.61C703.19 223.91 703.3 224.21 703.38 224.51C703.485 224.851 703.612 225.185 703.76 225.51C703.9 225.8 704.05 226.08 704.21 226.36C705.33 228.25 707 229.89 707.42 232.03C707.42 232.03 707.42 232.09 707.42 232.11C707.91 234.86 706.16 237.48 705.72 240.22C705.72 240.44 705.66 240.65 705.65 240.87C705.65 240.87 705.65 240.87 705.65 240.93C705.65 241.15 705.65 241.38 705.65 241.61C705.8 245.61 709.47 248.26 711.65 251.2C712.23 251.98 713.31 254.25 714.47 255.1C714.53 255.53 714.6 255.95 714.69 256.36C715.3 259.607 716.399 262.743 717.95 265.66C721.736 272.776 727.928 278.316 735.42 281.29C735.42 281.68 735.5 282.08 735.54 282.48C735.54 283.22 735.64 283.98 735.64 284.72C735.64 285.08 735.64 285.44 735.64 285.8L735.31 283.26C734.072 283.002 732.795 282.985 731.55 283.21C678.051 232.765 607.301 204.666 533.77 204.66V342.75C525.51 340.27 518.77 339.99 519.27 345.83C519.73 351.83 526.27 357.91 533.77 362.94V494.03H678.01C678.16 497.37 678.46 500.37 679.01 501.1C680.56 502.98 680.42 525.5 680.42 525.5C680.42 525.5 681.18 529.63 681.37 530.37C681.56 531.11 683.82 550.23 683.82 551.16C683.82 552.09 685.9 558.66 685.71 561.28C685.52 563.9 689.11 572.51 689.11 572.51L689.67 588.25C689.67 588.25 695.52 597.06 695.9 597.62C696.28 598.18 696.09 609.23 702.5 614.48C703.512 615.445 704.233 616.675 704.58 618.03C705.06 619.93 721.16 646.97 726.14 655.31L725.54 658.14L721.54 676.85L721.35 684.72C721.35 684.72 718.89 691.46 719.65 694.27C720.11 695.723 720.239 697.26 720.03 698.77C720.03 698.77 717.39 702.88 719.09 705.51C720.79 708.14 719.84 709.63 717.39 716.37C716.31 719.37 717.24 721.14 718.62 722.24C718.62 722.57 718.54 722.92 718.5 723.24C718.15 726.24 717.76 729.67 717.76 730.58C717.76 731.49 717.41 735.58 717.39 739.18C717.39 742.03 717.57 744.59 718.33 745.01C720.03 745.94 729.47 747.01 729.65 750.25C729.83 753.49 733.43 758.11 740.97 758.11C748.51 758.11 761.54 755.49 764.74 755.86C765.27 755.93 765.58 755.58 765.74 754.96C765.769 754.855 765.793 754.748 765.81 754.64C766.946 755.927 768.508 756.761 770.21 756.99C781.53 759.06 795.3 753.99 797.95 748.94C798.28 748.305 798.535 747.634 798.71 746.94C799.97 741.94 797.95 735.65 797.95 735.65C797.347 733.113 797.265 730.48 797.71 727.91C797.939 726.753 798.474 725.679 799.26 724.8C801.07 722.9 802.82 717.68 804 713.48C804.91 710.21 805.49 707.55 805.49 707.55C805.49 707.55 804.3 705.73 802.49 703.23C798.86 698.14 792.73 690.23 788.9 688.88C788.711 688.508 788.577 688.11 788.5 687.7C788.32 685.83 784.35 679.7 784.35 679.7C784.35 679.7 778.88 670.89 778.88 670.15C778.88 669.41 771.34 657.97 771.34 657.97C771.34 657.97 768.44 651.68 766.53 648.27C766.75 647.67 766.97 646.91 767.2 646.01C769.2 638.13 771.2 620.14 770.77 617.7C770.2 614.7 769.77 611.52 772.65 607.21C775.53 602.9 775.3 595.98 775.3 595.98C775.3 595.98 775.11 574.8 777.18 570.5C779.25 566.2 785.1 531.73 784.92 530.97C784.74 530.21 786.42 525.5 786.42 525.5L786.77 511.91V511.08C786.77 511.08 788.09 499.28 789.77 496.65C790.122 495.839 790.299 494.964 790.29 494.08H821.42C821.42 492.2 821.35 490.33 821.3 488.46H821.42C821.319 475.35 820.317 462.262 818.42 449.29C821.34 445.75 824.87 443.29 824.98 442.53C825.478 440.225 826.17 437.967 827.05 435.78C828.31 431.99 826.8 424.5 826.8 424.5ZM763.97 717.63C763.97 717.63 764.77 717.15 766.07 716.48C766.15 716.8 766.23 717.14 766.31 717.48C767.15 721.1 768.16 726.12 767.93 728.48C767.54 732.41 766.93 738.6 766.93 738.6C765.872 740.836 765.07 743.184 764.54 745.6C763.94 743.13 763.35 741.18 763.35 741.18C763.35 741.18 750.51 732.58 750.51 728.26C750.423 726.093 750.129 723.94 749.63 721.83C749.52 721.29 749.4 720.77 749.28 720.26C749.838 720.939 750.315 721.68 750.7 722.47C750.7 722.47 754.53 713.18 755.45 709.47C755.617 709.016 755.672 708.529 755.61 708.05C755.33 706.79 755.252 705.494 755.38 704.21C756.28 705.21 756.97 706.21 756.74 706.93C756.22 708.64 763.97 717.63 763.97 717.63Z",
  fill: "url(#paint0_linear)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M765.01 756.85C761.85 756.48 749.01 759.08 741.55 759.08C734.09 759.08 730.55 754.44 730.38 751.26C730.21 748.08 720.89 746.99 719.21 746.06C718.47 745.64 718.28 743.06 718.29 740.26C718.29 736.69 718.65 732.65 718.65 731.71C718.65 730.77 719.03 727.39 719.38 724.42C719.68 721.85 719.96 719.62 719.96 719.62C728.71 709.01 748.64 716.82 748.64 716.82C748.64 716.82 749.49 719.77 750.18 723.07C750.671 725.168 750.962 727.307 751.05 729.46C751.05 733.75 763.72 742.31 763.72 742.31C764.578 745.214 765.279 748.161 765.82 751.14C766.33 754.29 766.42 757.02 765.01 756.85Z",
  fill: "#53517C"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M765.01 756.84C761.85 756.48 749.01 759.08 741.56 759.08C734.11 759.08 730.56 754.43 730.39 751.26C730.22 748.09 720.89 746.98 719.21 746.05C718.47 745.64 718.28 743.05 718.29 740.26C721.85 741.34 726.81 743.11 728.53 744.94C731.32 747.94 732.06 751.26 733.93 751.64C735.8 752.02 737.65 754.64 746.58 752.38C752.16 750.98 760.4 750.97 765.82 751.16C766.33 754.29 766.42 757.01 765.01 756.84Z",
  fill: "black"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M799.08 725.95C795.92 729.3 797.79 736.74 797.79 736.74C797.79 736.74 800.39 744.94 797.79 749.97C795.19 755 781.59 759.97 770.42 757.97C769.353 757.849 768.333 757.469 767.447 756.862C766.561 756.255 765.838 755.441 765.34 754.49C762.61 749.11 767.25 739.72 767.25 739.72C767.25 739.72 767.81 733.58 768.19 729.67C768.41 727.31 767.41 722.32 766.59 718.72C766.04 716.36 765.59 714.59 765.59 714.59C765.59 714.59 782.59 690.2 787.75 690.02C787.996 690.008 788.242 690.035 788.48 690.1C792.22 691.02 798.59 699.28 802.3 704.51C804.07 707.01 805.25 708.82 805.25 708.82C805.25 708.82 802.26 722.6 799.08 725.95Z",
  fill: "#53517C"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M799.08 725.95C795.92 729.3 797.79 736.74 797.79 736.74C797.79 736.74 800.39 744.94 797.79 749.96C795.19 754.98 781.59 760.02 770.42 757.96C769.355 757.839 768.335 757.46 767.449 756.855C766.564 756.25 765.84 755.439 765.34 754.49C768.56 753.81 773.63 752.94 781.59 752.01C800.76 749.77 795.73 737.12 795.73 737.12C795.73 737.12 793.5 728.18 796.29 723.71C798.29 720.54 800.92 710.21 802.29 704.51C804.07 707 805.24 708.81 805.24 708.81C805.24 708.81 802.26 722.6 799.08 725.95Z",
  fill: "black"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M750.18 723.07C747.51 719.42 739.61 712.39 723.68 726.13C722.122 725.945 720.64 725.355 719.38 724.42C719.68 721.85 719.96 719.62 719.96 719.62C728.71 709.01 748.64 716.82 748.64 716.82C748.64 716.82 749.49 719.77 750.18 723.07Z",
  fill: "black"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M786.8 513.5V514.32L786.42 527.85C786.42 527.85 784.74 532.51 784.93 533.25C785.12 533.99 779.35 568.25 777.29 572.53C775.23 576.81 775.42 597.86 775.42 597.86C775.42 597.86 775.6 604.74 772.8 609.03C770 613.32 770.42 616.5 770.98 619.5C771.44 621.92 769.43 639.81 767.46 647.64C767.247 648.885 766.796 650.077 766.13 651.15C765.931 651.408 765.778 651.699 765.68 652.01C763 658.92 756.08 701.6 756.08 701.6C756.08 701.6 756.01 702.42 755.94 703.54C755.82 705.6 755.71 708.7 756.08 709.42C756.14 709.896 756.085 710.38 755.92 710.83C755.02 714.52 751.24 723.76 751.24 723.76C751.24 723.76 743.98 707.56 723.68 725.06C723.68 725.06 715.86 724.31 718.29 717.61C720.72 710.91 721.64 709.42 719.96 706.82C718.28 704.22 720.89 700.12 720.89 700.12C721.1 698.621 720.974 697.094 720.52 695.65C719.77 692.86 722.2 686.16 722.2 686.16L722.39 678.34L726.31 659.74L727.49 654.14L728.71 648.35L735.21 535.5L735.46 531.3L737.28 499.61L781.21 492.35L782.71 503.88L785.09 509.54L786.8 513.5Z",
  fill: "#B3D7F7"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M766.01 511.78L739.1 529.5L740.1 545.01C740.1 545.01 742.89 569.96 742.89 572.56C742.89 575.16 741.58 596.39 741.58 596.39C741.58 596.39 748.29 606.39 747.58 608.87C746.87 611.35 753.34 618.17 753.34 618.17L764.42 639.37C764.42 639.37 766.29 646.29 767.42 647.59C767.207 648.835 766.756 650.027 766.09 651.1C763.86 653.33 756.04 701.55 756.04 701.55C756.04 701.55 755.97 702.37 755.9 703.49C755.33 702.98 754.9 702.67 754.9 702.67C754.9 702.67 749.5 693.73 749.5 692.81C749.5 691.89 743.73 684.43 743.73 684.43L730.57 659.3L727.49 654.09L728.71 648.3L737.28 499.56L781.21 492.3L782.71 503.83L742.71 514.02L766.01 511.78Z",
  fill: "black"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M784.56 513.5L735.42 531.25L737.24 499.56L781.17 492.3L782.67 503.83L785.05 509.49C784.75 511.78 784.56 513.5 784.56 513.5Z",
  fill: "black"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M756.08 709.37C756.14 709.846 756.085 710.33 755.92 710.78C755.23 709.63 754.81 708.69 754.92 708.26C755.48 706.58 750.45 702.67 750.45 702.67C750.45 702.67 745.06 693.73 745.06 692.81C745.06 691.89 739.28 684.43 739.28 684.43L726.28 659.69L727.46 654.09L728.68 648.3L735.21 535.5L735.6 545.03C735.6 545.03 738.42 569.93 738.42 572.5C738.42 575.07 737.12 596.33 737.12 596.33C737.12 596.33 743.82 606.33 743.12 608.81C742.42 611.29 748.89 618.11 748.89 618.11L760.06 639.34C760.06 639.34 762.06 646.98 763.23 647.72C764.243 649.012 765.09 650.427 765.75 651.93C763.07 658.84 756.15 701.52 756.15 701.52C756.15 701.52 756.08 702.34 756.01 703.46C755.82 705.55 755.71 708.65 756.08 709.37Z",
  fill: "black"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M793.69 699.13C793.69 699.13 785.31 714.21 778.98 714.59C774.71 714.84 769.51 717.2 766.59 718.72C766.04 716.36 765.59 714.59 765.59 714.59C765.59 714.59 782.59 690.2 787.75 690.02C787.996 690.008 788.242 690.035 788.48 690.1C788.48 690.1 788.48 690.17 788.48 690.19C788.66 692.06 793.69 699.13 793.69 699.13Z",
  fill: "black"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M793.69 698.01C793.69 698.01 785.31 713.09 778.98 713.47C772.65 713.85 764.28 718.87 764.28 718.87C764.28 718.87 756.64 709.93 757.19 708.26C757.74 706.59 752.73 702.67 752.73 702.67C752.73 702.67 747.33 693.73 747.33 692.81C747.33 691.89 741.55 684.43 741.55 684.43L728.34 659.3C728.34 659.3 706.19 622.05 705.63 619.82C705.29 618.473 704.576 617.249 703.57 616.29C697.25 611.07 697.43 600.09 697.06 599.53L690.92 590.22L690.36 574.58C690.36 574.58 686.82 566.02 687.01 563.41C687.2 560.8 685.14 554.29 685.14 553.35C685.14 552.41 682.91 533.44 682.73 532.69C682.55 531.94 681.79 527.85 681.79 527.85C681.79 527.85 681.98 505.51 680.5 503.64C679.68 502.64 679.42 497.37 679.36 492.79C679.3 488.96 679.36 485.59 679.36 485.59L789.01 474.23C789.01 474.23 789.69 480.48 790.08 486.74C790.43 492.33 790.55 497.95 789.76 499.18C788.08 501.79 786.76 513.52 786.76 513.52L737.24 531.39L737.79 544.98C737.79 544.98 740.59 569.93 740.59 572.53C740.59 575.13 739.28 596.36 739.28 596.36C739.28 596.36 745.98 606.36 745.28 608.84C744.58 611.32 751.04 618.14 751.04 618.14L762.21 639.37C762.21 639.37 764.27 647.01 765.38 647.75C766.49 648.49 771.54 659.5 771.54 659.5C771.54 659.5 778.98 670.87 778.98 671.61C778.98 672.35 784.38 681.11 784.38 681.11C784.38 681.11 788.29 687.25 788.47 689.11C788.65 690.97 793.69 698.01 793.69 698.01Z",
  fill: "#B3D7F7"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M726.67 604.18C726.67 604.18 735.79 614.61 740.44 614.8C745.09 614.99 726.67 604.18 726.67 604.18Z",
  fill: "black"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M761.48 706.58C761.48 706.58 789.03 692.43 785.48 698.95C781.93 705.47 771.89 708.95 771.89 708.95L761.48 706.58Z",
  fill: "black"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M725.55 703.42C725.55 703.42 742.49 704.53 744.72 707.33C744.72 707.33 726.67 703.6 725.55 703.42Z",
  fill: "black"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M725.73 709.19C725.73 709.19 741.19 709.75 746.21 711.98C746.21 711.98 729.83 711.42 725.73 709.19Z",
  fill: "black"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M573.42 384.5L568.52 382.26L560.76 378.72C560.76 378.72 523.9 364.01 522.76 349.31C521.62 334.61 565.76 358.99 565.76 358.99C566.973 360.931 568.34 362.77 569.85 364.49C571.26 366.07 572.85 367.41 574.14 367.55C577.54 367.92 573.42 384.5 573.42 384.5Z",
  fill: "#C37871"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M778.42 304.81L766.32 318.81L736.91 309.14L729.65 303.36L734.29 297.22C735.88 295.12 736.36 291.92 736.29 288.62C736.29 287.88 736.29 287.12 736.19 286.38C735.854 282.674 735.158 279.01 734.11 275.44C734.11 275.44 775.99 264.82 773.01 273.57C772.434 275.388 772.197 277.296 772.31 279.2C772.501 282.309 773.116 285.378 774.14 288.32C774.992 290.928 776.045 293.465 777.29 295.91L778.42 304.81Z",
  fill: "#C37871"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M773.02 273.5C772.444 275.318 772.207 277.226 772.32 279.13C767.658 283.723 761.754 286.851 755.335 288.127C748.916 289.402 742.264 288.771 736.2 286.31C735.864 282.604 735.168 278.94 734.12 275.37C734.12 275.37 776 264.78 773.02 273.5Z",
  fill: "black"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M782.33 254.17C782.33 254.97 782.33 255.77 782.24 256.56C781.722 263.834 778.846 270.741 774.047 276.232C769.248 281.723 762.788 285.499 755.649 286.987C748.51 288.474 741.08 287.592 734.487 284.474C727.895 281.356 722.5 276.172 719.12 269.71C717.595 266.807 716.513 263.693 715.91 260.47C715.499 258.395 715.295 256.285 715.3 254.17C715.301 252.33 715.455 250.494 715.76 248.68C717.119 240.481 721.477 233.079 727.987 227.914C734.498 222.748 742.697 220.187 750.99 220.728C759.283 221.269 767.08 224.873 772.864 230.841C778.648 236.809 782.008 244.714 782.29 253.02C782.32 253.4 782.33 253.79 782.33 254.17Z",
  fill: "#C37871"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M778.42 304.81L766.32 318.81L736.91 309.14L729.65 303.36L734.29 297.22C735.88 295.12 736.36 291.92 736.29 288.62L737.63 298.89L737.95 299.21L739.87 301.13H742.29L746.95 307.46C746.95 307.46 753.65 302.07 754.21 303.36C754.77 304.65 763.89 301.13 763.89 301.13H764.24C772.5 300.78 773.94 288.48 773.94 288.48C773.94 288.48 774.07 288.37 774.14 288.33C774.992 290.938 776.045 293.475 777.29 295.92L778.42 304.81Z",
  fill: "black"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M790.1 486.74C789.89 487.55 789.66 488.34 789.41 489.13C782.15 512.21 729.83 512.77 729.83 512.77L728.34 498.44L723.34 508.12C723.34 508.12 690.96 499.18 679.39 492.79C679.33 488.96 679.39 485.59 679.39 485.59L789.04 474.23C789.04 474.23 789.71 480.5 790.1 486.74Z",
  fill: "black"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M573.42 384.5L568.52 382.26C569.65 376.94 569.85 366.38 569.88 364.49C571.29 366.07 572.88 367.41 574.17 367.55C577.54 367.92 573.42 384.5 573.42 384.5Z",
  fill: "black"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M788.47 434.39C788.47 434.39 796.67 463.81 789.41 486.9C782.15 509.99 729.83 510.5 729.83 510.5L728.34 496.17L723.34 505.86C723.34 505.86 684.25 495.05 676.62 488.72C668.99 482.39 672.89 472.9 672.89 472.9C672.89 472.9 675.5 460.62 677.73 458C679.96 455.38 680.34 446.27 679.59 445C678.84 443.73 682.2 431.4 683.32 429.54C684.44 427.68 683.13 377.97 683.13 377.97C683.13 377.97 666.56 385.41 665.63 387.65C664.7 389.89 645.15 400.65 645.15 400.65C645.15 400.65 626.72 402.89 623.37 402.89C620.02 402.89 601.58 400.65 601.58 400.65C601.58 400.65 596.58 400.46 595.07 399.35C593.555 398.447 591.923 397.757 590.22 397.3C590.22 397.3 585.02 396.18 583.52 394.14C582.02 392.1 569.52 385.2 569.52 385.2C571.94 383.71 572.13 364.2 572.13 364.2L595.77 369.97C595.77 369.97 597.27 366.81 599.5 368.11C601.73 369.41 615.33 370.5 615.33 370.5C615.33 370.5 626.69 368.27 627.25 369.19C627.81 370.11 629.48 369.94 629.48 369.94C629.48 369.94 631.72 369.75 631.72 369.02C631.72 368.29 633.72 369.19 633.72 369.19L637.45 369.75C637.45 369.75 636.89 364.92 638.57 364.55C639.048 364.433 639.48 364.175 639.81 363.809C640.14 363.444 640.352 362.988 640.42 362.5C640.42 362.5 645.42 355.8 647.87 355.8C650.32 355.8 651.97 349.1 651.97 349.1L660.91 339.98C660.91 339.98 659.79 335.32 660.91 335.13C662.03 334.94 662.2 332.9 662.2 332.9C662.2 332.9 662.58 328.81 664.63 327.9C666.68 326.99 667.79 321.58 667.79 321.58C667.79 321.58 677.28 310.97 678.03 307.24C678.78 303.51 682.69 302.77 682.69 302.77C684.804 301.4 687.128 300.387 689.57 299.77C692.74 299.21 701.12 298.27 701.12 298.27C701.12 298.27 716.38 296.98 717.88 295.27C719.38 293.56 721.97 293.77 723.64 293.77C724.002 293.744 724.348 293.616 724.64 293.4C726.15 292.46 727.95 289.84 729.75 288.19C731.98 286.14 735.89 287.07 735.89 287.07L737.57 299.92L737.88 300.23L739.8 302.15H742.22L746.88 308.49C746.88 308.49 753.58 303.09 754.14 304.39C754.7 305.69 763.82 302.15 763.82 302.15H764.17C772.43 301.8 773.87 289.51 773.87 289.51C777.97 285.96 781.51 300.87 781.51 300.87L782.8 301.56C785.42 303.02 791.22 306.36 791.93 307.94C792.86 309.94 803.29 316.12 803.29 316.12L788.47 434.39Z",
  fill: "#53517C"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M793.32 479.07L787.82 483.5L781.59 488.5C781.59 488.5 770.04 515.5 754.22 507.87C738.4 500.24 775.42 472 775.42 472L780.54 469.52L786.21 466.78L793.32 479.07Z",
  fill: "#C37871"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M736.84 302.5C731.09 304.89 723.84 310.57 723.84 310.57L723.57 295.68C725.08 294.73 726.88 292.12 728.68 290.46C730.91 288.46 734.82 289.35 734.82 289.35L736.5 302.19L736.84 302.5Z",
  fill: "black"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M737.96 300.28C732.21 302.67 724.96 308.35 724.96 308.35L724.72 293.5C726.23 292.56 728.03 289.94 729.83 288.29C732.06 286.24 735.97 287.17 735.97 287.17L737.65 300.02L737.96 300.28Z",
  fill: "#E6EAED"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M782.88 304.95C780.02 312.61 776.46 321.09 775.82 317.84C775.05 313.99 768.34 308.55 764.25 305.54C772.51 305.2 773.95 292.9 773.95 292.9C778.05 289.36 781.59 304.26 781.59 304.26L782.88 304.95Z",
  fill: "black"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M782.88 301.6C780.02 309.26 776.46 317.74 775.82 314.49C775.05 310.64 768.34 305.2 764.25 302.19C772.51 301.84 773.95 289.55 773.95 289.55C778.05 286 781.59 300.91 781.59 300.91L782.88 301.6Z",
  fill: "#E6EAED"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M744.91 595.62C744.91 595.62 766.13 592.62 765.2 597.11C764.27 601.6 744.91 595.62 744.91 595.62Z",
  fill: "black"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M710.65 522.5C710.65 522.5 719.03 518.03 726.48 519.9L710.65 522.5Z",
  fill: "black"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M697.06 510.35C697.06 510.35 710.47 508.3 715.49 510.54L697.06 510.35Z",
  fill: "black"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M755.71 541.07C755.71 541.07 743.98 553.54 744.71 556.89L755.71 541.07Z",
  fill: "black"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M641.21 373.7C641.21 373.7 639.35 380.4 650.71 383.19L641.21 373.7Z",
  fill: "black"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M637.86 385.24C637.86 385.24 651.86 397.71 645.31 398.09C638.76 398.47 637.86 385.24 637.86 385.24Z",
  fill: "black"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M668.95 335.16C668.95 335.16 686.08 347.07 684.95 349.87C683.82 352.67 668.95 335.16 668.95 335.16Z",
  fill: "black"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M793.32 479.07L787.82 483.5C786.67 479.56 784.29 472.96 780.57 469.5L786.24 466.76L793.32 479.07Z",
  fill: "black"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M795.92 320.82L803.37 316.17C803.37 316.17 811.93 317.47 813.05 335.17C814.17 352.87 821.99 388.23 821.99 388.23L826.27 427.5C826.27 427.5 827.76 434.95 826.46 438.67C825.603 440.842 824.934 443.084 824.46 445.37C824.27 446.68 814.03 453.01 814.22 461.2C814.41 469.39 801.22 477.02 801.22 477.02C801.22 477.02 792.65 482.02 789.86 485.59C789.86 485.59 786.69 470.69 779.81 466.97C772.93 463.25 794.33 433.65 794.33 433.65L795.92 320.82Z",
  fill: "#53517C"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M783.04 434.15C783.04 434.15 760.7 443.46 762.56 446.44C764.42 449.42 783.04 434.15 783.04 434.15Z",
  fill: "black"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M783.04 446.06C783.04 446.06 773.75 450.17 774.52 451.48C775.29 452.79 783.04 446.06 783.04 446.06Z",
  fill: "black"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M777.83 453.88C777.83 453.88 768.54 457.99 769.31 459.3C770.08 460.61 777.83 453.88 777.83 453.88Z",
  fill: "black"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M537.1 214.58V496.58H820.93C819.64 340.83 693.13 214.9 537.1 214.58Z",
  fill: "#5AC8FA"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M537.1 214.58V496.58H820.93C819.64 340.83 693.13 214.9 537.1 214.58Z",
  fill: "black"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M537.1 209V491H820.93C819.64 335.24 693.13 209.31 537.1 209Z",
  fill: "#64D2FF"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M755.76 498.89C755.735 497.347 756.197 495.835 757.08 494.57C757.966 493.708 759.062 493.094 760.26 492.79C761.32 492.44 762.39 492.11 763.46 491.79C764.292 491.512 765.163 491.37 766.04 491.37C767.82 491.44 769.36 492.54 770.79 493.59C771.072 493.766 771.306 494.01 771.47 494.3C771.79 495.04 771.1 495.81 770.47 496.3C768.267 498.26 765.887 500.01 763.36 501.53C761.58 502.53 759.22 503.66 757.13 503.68C754.56 503.75 755.59 500.75 755.76 498.89Z",
  fill: "#C37871"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M782.33 254.17C782.33 254.97 782.33 255.77 782.24 256.56C782.098 256.655 781.951 256.742 781.8 256.82C781.234 257.025 780.682 257.268 780.15 257.55C778.52 258.66 778.89 261.08 779.04 263.04C779.273 265.877 778.683 268.721 777.34 271.23C776.7 271.164 776.1 270.889 775.632 270.448C775.164 270.007 774.854 269.425 774.75 268.79C774.572 267.522 774.518 266.239 774.59 264.96C774.43 261.54 772.59 258.49 771.39 255.27C769.17 249.1 769.66 242.27 768.18 235.9C767.75 234.02 767.05 232.02 765.45 230.9C763.33 229.44 760.39 230.08 758.11 231.27C755.83 232.46 753.79 234.2 751.32 234.95C747.51 236.1 743.46 234.71 739.67 233.53C735.88 232.35 731.59 231.35 728.05 233.16C724.33 235.07 722.66 239.42 721.52 243.46C721.146 244.567 720.966 245.731 720.99 246.9C721.06 247.9 721.45 248.95 721.42 250C721.42 252.24 719.51 254 718.77 256.12C718.31 257.43 718.42 260.66 716.52 260.64C716.303 260.633 716.093 260.567 715.91 260.45C715.499 258.375 715.295 256.265 715.3 254.15C715.301 252.31 715.455 250.474 715.76 248.66C717.119 240.461 721.477 233.059 727.987 227.894C734.498 222.728 742.697 220.167 750.99 220.708C759.283 221.249 767.08 224.853 772.864 230.821C778.648 236.789 782.008 244.694 782.29 253C782.32 253.4 782.33 253.79 782.33 254.17Z",
  fill: "black"
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M706.97 245.8C706.85 242.57 709.3 239.55 708.74 236.37C708.3 233.88 706.14 232.07 705.09 229.77C704.485 228.388 704.284 226.863 704.509 225.372C704.733 223.88 705.375 222.482 706.36 221.34C707.18 220.42 708.21 219.7 709 218.76C710.57 216.88 711 214.35 711.75 212.01C712.5 209.67 713.75 207.22 716.08 206.42C718.59 205.56 721.53 206.96 723.95 205.87C724.244 205.762 724.509 205.586 724.722 205.357C724.936 205.127 725.093 204.851 725.18 204.55C725.201 204.103 725.157 203.655 725.05 203.22C724.88 201.44 726.57 200.05 728.19 199.27C735.59 195.7 744.33 197.4 752.35 199.17C752.216 197.542 752.334 195.902 752.7 194.31C757.76 194.87 763.21 195.61 766.87 199.13C769.14 201.32 770.41 204.3 771.87 207.06C773.33 209.82 775.33 212.59 778.26 213.74C779.218 213.972 780.117 214.401 780.9 215C781.341 215.489 781.68 216.06 781.9 216.68L783.82 221.41C784.019 221.987 784.317 222.525 784.7 223C785.211 223.467 785.778 223.867 786.39 224.19C790.11 226.62 790.66 231.97 789.5 236.27C788.34 240.57 785.92 244.46 785 248.82C784.46 251.39 784.15 254.53 781.8 255.7C781.234 255.91 780.683 256.157 780.15 256.44C778.52 257.54 778.88 259.96 779.04 261.92C779.274 264.756 778.687 267.599 777.35 270.11C776.71 270.045 776.109 269.771 775.64 269.33C775.172 268.889 774.863 268.305 774.76 267.67C774.578 266.402 774.521 265.119 774.59 263.84C774.43 260.42 772.59 257.37 771.39 254.15C769.17 247.98 769.66 241.15 768.19 234.78C767.75 232.89 767.04 230.9 765.44 229.78C763.32 228.31 760.38 228.94 758.1 230.15C755.82 231.36 753.79 233.07 751.32 233.82C747.51 234.96 743.46 233.59 739.66 232.39C735.86 231.19 731.59 230.22 728.05 232.03C724.33 233.94 722.67 238.3 721.53 242.33C721.15 243.436 720.964 244.6 720.98 245.77C721.06 246.77 721.44 247.83 721.42 248.87C721.42 251.12 719.51 252.87 718.77 255C718.31 256.31 718.42 259.53 716.52 259.52C715.08 259.52 713.62 256.26 712.91 255.31C710.74 252.42 707.12 249.75 706.97 245.8Z",
  fill: "#4B3E3C"
});

var _ref57 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  opacity: 0.1,
  d: "M708.74 234.13C708.3 231.64 706.14 229.84 705.09 227.54C704.795 226.885 704.597 226.191 704.5 225.48C704.287 226.937 704.492 228.425 705.09 229.77C706.09 232.05 708.24 233.84 708.72 236.28C708.847 235.57 708.853 234.843 708.74 234.13Z",
  fill: "black"
}), React.createElement("path", {
  opacity: 0.1,
  d: "M725.18 202.31C725.185 202.257 725.185 202.203 725.18 202.15C725.125 202.302 725.085 202.46 725.06 202.62C725.115 202.523 725.155 202.419 725.18 202.31Z",
  fill: "black"
}), React.createElement("path", {
  opacity: 0.1,
  d: "M752.35 196.94C752.345 196.863 752.345 196.787 752.35 196.71C752.35 196.78 752.35 196.86 752.35 196.93V196.94Z",
  fill: "black"
}), React.createElement("path", {
  opacity: 0.1,
  d: "M789.5 234.03C788.35 238.33 785.92 242.23 785 246.58C784.46 249.16 784.15 252.29 781.8 253.47C781.236 253.681 780.685 253.924 780.15 254.2C778.8 255.12 778.82 256.94 778.96 258.66C778.98 258.225 779.097 257.799 779.303 257.415C779.509 257.031 779.798 256.698 780.15 256.44C780.683 256.157 781.234 255.91 781.8 255.7C784.15 254.53 784.46 251.39 785 248.82C785.92 244.46 788.35 240.57 789.5 236.27C789.962 234.588 790.131 232.839 790 231.1C789.926 232.09 789.759 233.071 789.5 234.03Z",
  fill: "black"
}), React.createElement("path", {
  opacity: 0.1,
  d: "M777.35 267.88C776.71 267.816 776.109 267.541 775.64 267.1C775.172 266.659 774.863 266.075 774.76 265.44C774.578 264.169 774.521 262.882 774.59 261.6C774.43 258.19 772.59 255.13 771.39 251.92C769.17 245.75 769.66 238.92 768.19 232.55C767.75 230.66 767.04 228.67 765.44 227.55C763.32 226.09 760.38 226.72 758.1 227.92C755.82 229.12 753.79 230.85 751.32 231.59C747.51 232.74 743.46 231.36 739.66 230.17C735.86 228.98 731.59 227.99 728.05 229.81C724.33 231.72 722.67 236.08 721.53 240.1C721.15 241.21 720.964 242.377 720.98 243.55C720.98 243.78 721.04 244.02 721.08 244.25C721.189 243.604 721.339 242.966 721.53 242.34C722.67 238.34 724.33 233.95 728.05 232.04C731.59 230.23 735.87 231.21 739.66 232.4C743.45 233.59 747.51 234.97 751.32 233.83C753.79 233.08 755.82 231.36 758.1 230.16C760.38 228.96 763.32 228.32 765.44 229.79C767.04 230.88 767.75 232.87 768.19 234.79C769.66 241.18 769.19 247.99 771.39 254.16C772.54 257.38 774.39 260.43 774.59 263.85C774.521 265.129 774.578 266.412 774.76 267.68C774.863 268.315 775.172 268.899 775.64 269.34C776.109 269.781 776.71 270.056 777.35 270.12C778.675 267.629 779.265 264.813 779.05 262C778.893 264.056 778.315 266.058 777.35 267.88Z",
  fill: "black"
}), React.createElement("path", {
  opacity: 0.1,
  d: "M718.77 252.79C718.31 254.1 718.42 257.32 716.52 257.31C715.08 257.31 713.62 254.06 712.91 253.11C710.91 250.4 707.65 247.91 707.06 244.42C706.985 244.876 706.955 245.338 706.97 245.8C707.12 249.75 710.74 252.42 712.91 255.34C713.62 256.34 715.08 259.54 716.52 259.55C718.42 259.55 718.31 256.34 718.77 255.03C719.51 252.91 721.37 251.15 721.42 248.9C721.418 248.47 721.372 248.041 721.28 247.62C720.85 249.43 719.42 250.98 718.77 252.79Z",
  fill: "black"
}));

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M63.11 446.6H59.75V450.02H63.11V446.6Z",
  fill: "#007AFF"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.25,
  d: "M63.11 446.6H59.75V450.02H63.11V446.6Z",
  fill: "black"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M347.73 164.94H344.45V168.75H347.73V164.94Z",
  fill: "#007AFF"
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.25,
  d: "M347.73 164.94H344.45V168.75H347.73V164.94Z",
  fill: "black"
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.2,
  d: "M347.76 450.03V168.03H347.17C190.86 168.03 64.02 294.11 62.75 450.12L347.76 450.03Z",
  fill: "white"
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M347.76 450.03V168.03H347.17C190.86 168.03 64.02 294.11 62.75 450.12L347.76 450.03Z",
  fill: "#007AFF"
});

var _ref64 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.25,
  d: "M347.76 450.03V168.03H347.17C190.86 168.03 64.02 294.11 62.75 450.12L347.76 450.03Z",
  fill: "black"
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  d: "M344.76 447.03V165.03H344.17C187.86 165.03 61.02 291.11 59.75 447.12L344.76 447.03Z",
  fill: "#0A84FF"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.15,
  d: "M344.76 447.03V165.03H344.17C187.86 165.03 61.02 291.11 59.75 447.12L344.76 447.03Z",
  fill: "black"
});

var _ref67 =
/*#__PURE__*/
React.createElement("path", {
  d: "M554.55 677.37L558.74 680V685L553.05 684.12L554.55 677.37Z",
  fill: "#34C759"
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M554.55 677.37L558.74 680V685L553.05 684.12L554.55 677.37Z",
  fill: "black"
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  d: "M154.92 679.37L153.35 679.84V684.84L158.67 683.68L157.36 678.81L154.92 679.37Z",
  fill: "#34C759"
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M154.92 679.37L153.35 679.84V684.84L158.67 683.68L157.36 678.81L154.92 679.37Z",
  fill: "black"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M359.69 485.96L153.35 684.84C179.803 711.741 211.344 733.11 246.137 747.701C280.93 762.292 318.278 769.814 356.006 769.829C393.735 769.844 431.089 762.351 465.893 747.787C500.697 733.224 532.256 711.88 558.73 685L359.69 485.96Z",
  fill: "#6C63FF"
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  d: "M359.69 480.96L153.35 679.84C179.803 706.741 211.344 728.11 246.137 742.701C280.93 757.292 318.278 764.814 356.006 764.829C393.735 764.844 431.089 757.351 465.893 742.787C500.697 728.224 532.256 706.88 558.73 680L359.69 480.96Z",
  fill: "#34C759"
});

var _ref73 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M359.69 480.96L153.35 679.84C179.803 706.741 211.344 728.11 246.137 742.701C280.93 757.292 318.278 764.814 356.006 764.829C393.735 764.844 431.089 757.351 465.893 742.787C500.697 728.224 532.256 706.88 558.73 680L359.69 480.96Z",
  fill: "black"
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  d: "M359.69 485.96L153.35 684.84C179.803 711.741 211.344 733.11 246.137 747.701C280.93 762.292 318.278 769.814 356.006 769.829C393.735 769.844 431.089 762.351 465.893 747.787C500.697 733.224 532.256 711.88 558.73 685L359.69 485.96Z",
  fill: "#34C759"
});

var _ref75 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.99 475.06L349.86 470.36L350.86 472.36L343.02 478.09L342.99 475.06Z",
  fill: "#64D2FF"
});

var _ref76 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M342.99 475.06L349.86 470.36L350.86 472.36L343.02 478.09L342.99 475.06Z",
  fill: "black"
});

var _ref77 =
/*#__PURE__*/
React.createElement("path", {
  d: "M338.11 468.03L345.36 465.36L346.36 467.36L333.99 471.53L338.11 468.03Z",
  fill: "#FF453A"
});

var _ref78 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M338.11 468.03L345.36 465.36L346.36 467.36L333.99 471.53L338.11 468.03Z",
  fill: "black"
});

var _ref79 =
/*#__PURE__*/
React.createElement("path", {
  d: "M337.2 459.28L344.86 458.86V460.86L331.99 462.21L333.14 459.62L337.2 459.28Z",
  fill: "#007AFF"
});

var _ref80 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M337.2 459.28L344.86 458.86V460.86L331.99 462.21L333.14 459.62L337.2 459.28Z",
  fill: "black"
});

var _ref81 =
/*#__PURE__*/
React.createElement("path", {
  d: "M344.86 458.86L67.51 522.02C63.1724 502.061 60.9899 481.695 61 461.27C61 460.46 61 459.66 61 458.86H344.86Z",
  fill: "#007AFF"
});

var _ref82 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M344.86 458.86L67.51 522.02C63.1724 502.061 60.9899 481.695 61 461.27C61 460.46 61 459.66 61 458.86H344.86Z",
  fill: "black"
});

var _ref83 =
/*#__PURE__*/
React.createElement("path", {
  d: "M344.86 460.86L67.51 524.02C63.1724 504.061 60.9899 483.695 61 463.27C61 462.46 61 461.66 61 460.86H344.86Z",
  fill: "#0A84FF"
});

var _ref84 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.01 528.5C73.8529 555.364 83.5962 581.228 96.93 605.27L345.36 465.36L68.01 528.5Z",
  fill: "#FF3B30"
});

var _ref85 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M68.01 528.5C73.8529 555.364 83.5962 581.228 96.93 605.27L345.36 465.36L68.01 528.5Z",
  fill: "black"
});

var _ref86 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.01 530.5C74.8529 557.364 84.5962 583.228 97.93 607.27L346.36 467.36L69.01 530.5Z",
  fill: "#FF453A"
});

var _ref87 =
/*#__PURE__*/
React.createElement("path", {
  d: "M349.31 470.38L101.31 610.07L101.43 610.29C113.99 633.007 129.602 653.898 147.83 672.38L349.83 470.38H349.31Z",
  fill: "#64D2FF"
});

var _ref88 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M349.31 470.38L101.31 610.07L101.43 610.29C113.99 633.007 129.602 653.898 147.83 672.38L349.83 470.38H349.31Z",
  fill: "black"
});

var _ref89 =
/*#__PURE__*/
React.createElement("path", {
  d: "M350.31 472.38L102.31 612.07L102.43 612.29C114.99 635.007 130.602 655.898 148.83 674.38L350.83 472.38H350.31Z",
  fill: "#64D2FF"
});

var _ref90 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 673.37,
  y1: 758.09,
  x2: 673.37,
  y2: 189.88,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})));

var SvgPieChart = function SvgPieChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 908,
    height: 789,
    viewBox: "0 0 908 789",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPieChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pie_chart.3a2f9f11.svg";
export { ForwardRef as ReactComponent };